import React, { useEffect, useRef } from "react";

const DisableRightClick = ({ children }) => {
  const touchStartTime = useRef(null);

  useEffect(() => {
    const handleContextMenu = (event) => {
      event.preventDefault(); // Disabilita clic destro
    };

    const handleTouchStart = (event) => {
      if (event.touches.length === 1) {
        touchStartTime.current = Date.now();
      }
    };

    const handleTouchEnd = (event) => {
      if (!touchStartTime.current) return;
      const duration = Date.now() - touchStartTime.current;
      // Se il tap è stato lungo, blocchiamo il comportamento predefinito
      if (duration > 500) {
        event.preventDefault();
      }
      touchStartTime.current = null;
    };

    // Aggiungi i listener globali
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("touchstart", handleTouchStart, { passive: false });
    document.addEventListener("touchend", handleTouchEnd, { passive: false });

    // Cleanup
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);

  return <div>{children}</div>;
};

export default DisableRightClick;
